{
  "assistant.page.title": "AI access",
  "assistant.page.lede": "Connect AI clients through OAuth and MCP, review what they changed, and keep continuity under your control.",
  "assistant.page.privacy": "MCP only · no provider keys",
  "assistant.page.open": "Open AI access",
  "assistant.page.boundary.title": "Your client connects; Exognitos does not call a model provider",
  "assistant.page.boundary.description": "Exognitos exposes permission-scoped tools through MCP. It stores no model-provider API key and sends no account context to a model service. Every call derives its owner and authority again from the connected client's verified credential.",
  "assistant.page.review.title": "Review and accountability",
  "assistant.page.review.description": "Accept or reject proposed memories, inspect action receipts and provenance, and review profile facts before they become trusted context.",
  "assistant.page.profile.action": "Review profile facts"
}
